import { Location } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';
import { CustomerService } from 'src/services/customer.service';
import { ProfileService } from 'src/services/profile.service';

@Component({
    selector: 'app-merge-profile',
    templateUrl: './merge-profile.component.html',
    styleUrls: ['./merge-profile.component.scss'],
    standalone: false
})
export class MergeProfileComponent implements OnInit {
  private sharedService = inject(SharedService);
  private activeModal = inject(NgbActiveModal);
  private location = inject(Location);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private customerService = inject(CustomerService);
  private profileService = inject(ProfileService);

  @Input() profileList: Profile[];
  @Input() selectedCustomer: Customer;

  selectedProfile: Profile;

  disabledSubmit = false;
  mergeSimpan = true;

  searchName: string;
  searchICNum: string;
  searchLeadID: number;

  isForceMove = false;

  customerList: Customer[] = [];

  ngOnInit(): void {
    for (let i = 0; i < this.profileList.length; i++) {
      if (Number(this.profileList[i].ID) != Number(this.selectedProfile.ID))
        this.getProfileDetails(i);
    }
  }

  async getProfileDetails(index: number) {
    const p = await this.profileService.getProfile(this.profileList[index].ID);
    this.profileList[index].Reserve = p.Reserve;
    this.profileList[index].BadDebt = p.BadDebt;
  }

  reset() {
    this.activeModal.close();
  }

  confirmBeforeUpdate(profile: Profile) {
    this.disabledSubmit = true;

    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to merge profile " +
      this.selectedProfile.ID + "-" + this.selectedProfile.Occupation + " to " + profile.ID + "-" + profile.Occupation;

    modalRef.result.then((confirm) => {
      if (confirm)
        this.mergeProfile(this.selectedProfile.ID, profile.ID);
      else
        this.disabledSubmit = false;
    });

    return proceed;
  }

  async mergeProfile(source: number, target: number) {
    await this.profileService.mergeProfiles({ sourceId: source, targetId: target, mergeReserve: this.mergeSimpan });
    const urls = window.location.pathname.split("/")
    this.location.replaceState(urls[1] + "/" + urls[2]);
    window.location.reload();
  }

  detectEnableSearch() {
    if (this.searchICNum == "" && this.searchName == "")
      this.disabledSubmit = true;
    else
      this.disabledSubmit = false;

    return this.disabledSubmit;
  }

  findCustomer(name: string, ic: string, leadCustomerID: number) {
    this.disabledSubmit = true;
    this.customerList.splice(0, this.customerList.length);
    if (ic != undefined)
      var icNumberFormat = this.sharedService.sanitizeICNumInput(ic)
    let xhr;
    xhr = this.restApi.getRequest(this.constructApi.getCompanyCustomerSearch(this.selectedCustomer.CompanyId, name, icNumberFormat));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          const jsonArray = JSON.parse((xhr.responseText));

          if (jsonArray.length == 0) {
            this.sharedService.openAlert("Customer not found!", ALERT_TYPE.DANGER)
          }
          else {
            jsonArray.forEach(json => {
              // create customer instance with all response data

              if (Number(json.id) != Number(this.selectedCustomer.ID)) {
                const cust = new Customer();
                cust.ID = json.id;
                cust.Name = json.name;
                cust.ICNumber = json.icNumber;
                cust.CompanyCode = json.companyCode;
                //add customer instance into customer list
                this.customerList.push(cust);
              }
            });

            if (this.customerList.length == 0)
              this.sharedService.openAlert("Do not have any other customer with these search criteria", ALERT_TYPE.DANGER)
          }
        }
        else {
          this.sharedService.openAlert("Error! " + JSON.parse((xhr.responseText)).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  async getFromLeads() {
    this.disabledSubmit = true;
    this.customerList.splice(0, this.customerList.length);
    try {
      this.customerList = await this.customerService.getCompanyLeads(this.selectedCustomer.CompanyId);
      this.customerList = this.customerList.filter(lead => lead.ID !== this.selectedCustomer.ID);
      if (this.customerList.length == 0)
        this.sharedService.openAlert("Customer not found!", ALERT_TYPE.DANGER);
    } finally {
        this.disabledSubmit = false;
    }
  }

  confirmBeforeMove(customer: Customer, isForceMove: boolean) {
    this.disabledSubmit = true;

    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to move profile " +
      this.selectedProfile.ID + "-" + this.selectedProfile.Occupation + " to " + customer.ID + "-" + customer.Name + "(" + customer.ICNumber + ")";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.moveProfile(this.selectedProfile.ID, customer.ID, isForceMove);
      else
        this.disabledSubmit = false;
    });

    return proceed;
  }

  async moveProfile(profileId: number, customerId: number, isForceMove: boolean) {
    this.disabledSubmit = true;
    try {
      await this.profileService.moveProfile(profileId, customerId, isForceMove);
      const urls = window.location.pathname.split("/");
      this.location.replaceState(urls[1] + "/" + customerId);
      window.location.reload();
    } finally {
      this.disabledSubmit = false;
    }
  }

  setActive(action: string) {
    if (action == "Merge") {
      if (this.profileList.length > 1) return "active";
    }
    else
      if (this.profileList.length == 1) return "active";
  }
}
